import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Icon from '../Header/Icon';

function Footer() {
    const { t, i18n } = useTranslation();
    const isRTL = ['ar', 'ckb'].includes(i18n.language || localStorage.getItem("lang"));

    return (
        <footer className=" text-gray-900 bg-white py-3 shadow-2xl shadow-black/60 ">
            <div className={`container mx-auto px-4 md:px-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                <div className={`flex flex-col md:flex-row items-center justify-between gap-6 ${isRTL ? 'flex-row-reverse' : ''}`}>
                    {/* Logo Section */}
                    <Link to="/" className="group transition duration-300">
                        <div className="flex items-center gap-2">
                            {/* Add your logo image component here if available */}
                            <div className="flex flex-col">
                                <div className={`flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
                                    <p className="text-2xl font-bold text-[#07A024] group-hover:text-[rgb(7,160,25)] transition-colors">
                                        {t("zad")}
                                    </p>
                                    <p className="text-2xl text-gray-900  transition-colors">
                                        {t("organization")}
                                    </p>
                                </div>
                                
                            </div>
                        </div>
                    </Link>

                    {/* Icons and Social Media */}
                    <div className="hidden md:flex flex-col items-center gap-4">
                        <div className="flex space-x-6">
                            <Icon />
                            
                        </div>
       
                    </div>
                </div>

            </div>
        </footer>
    );
}

export default Footer;